module.exports = __webpack_public_path__ + "static/etf-equivalent-static-dc78e77189de52ae2b91859512a4cead.png";